import type { EVBarriersData } from '../../services/evAdoptionBarriersService';
import { getAuthoredOverview, renderAuthoredNarrativeBundle } from './authoredNarrativeRender';

const CHART_ID = 'ev_barriers';
const VIEW_ID = 'income_quintile';

export function buildEvBarriersAuthoredBundle(locationName: string, data: EVBarriersData | null) {
  if (!data?.quintiles?.length) {
    return renderAuthoredNarrativeBundle(CHART_ID, VIEW_ID, { locationName });
  }
  const sorted = [...data.quintiles].sort((a, b) => a.quintile - b.quintile);
  const low = sorted[0];
  const high = sorted[sorted.length - 1];
  const sampleSentence =
    data.metrics.sampleSize > 0
      ? ` Analysis included ${data.metrics.sampleSize} tracts in ${data.county} County.`
      : '';
  const tokens = {
    locationName,
    groupHighValue: high.avgEVAdoption.toFixed(2),
    groupLowValue: low.avgEVAdoption.toFixed(2),
    highGroupLabel: `Q${high.quintile} (higher income)`,
    lowGroupLabel: `Q${low.quintile} (lower income)`,
    gradientSentence:
      data.metrics.quintileGap > 0
        ? ` EV adoption varied across tract income quintiles in the displayed data.`
        : '',
    sampleSentence,
  };
  return renderAuthoredNarrativeBundle(CHART_ID, VIEW_ID, tokens);
}

export function evBarriersOverviewDescription(): string {
  return getAuthoredOverview(
    CHART_ID,
    VIEW_ID,
    'Tract-level association between EV adoption rates and income quintiles (exploratory).'
  );
}

export function buildEvBarriersKeyInsights(locationName: string, data: EVBarriersData | null): string {
  const bundle = buildEvBarriersAuthoredBundle(locationName, data);
  return bundle.keyInsights || `EV adoption and income data are not available for ${locationName}.`;
}
